import { arrotonda, type Dec } from './dec'

/**
 * Ripartisce sui mesi un consumo di cui si conosce solo il dato di fine periodo.
 * `iniziale` e' la lettura di fine del mese precedente il periodo; le letture
 * prodotte sono di fine mese e l'ultima coincide con `finale`.
 *
 * ponytail: passo costante arrotondato, il resto della divisione finisce
 * nell'ultimo mese. Se serve distribuirlo, spalmarlo sugli ultimi mesi.
 */
export function spalmaLetture(
  iniziale: Dec,
  finale: Dec,
  mesi: readonly number[],
  decimali: number,
): { mese: number; valore: Dec }[] {
  if (finale.lt(iniziale)) {
    throw new Error('Il valore finale non puo essere decrescente rispetto all iniziale')
  }

  const passo = arrotonda(finale.minus(iniziale).div(mesi.length || 1), decimali)
  return mesi.map((mese, i) => ({
    mese,
    valore: i === mesi.length - 1 ? finale : arrotonda(iniziale.plus(passo.times(i + 1)), decimali),
  }))
}
